<template>
  <div class="marketing results">
    <section class="summary">
      <dl class="panels">
        <div>
          <dt>{{ $t('campaigns total') }}</dt>
          <dd>
            <span class="value">{{ results.campaignStats.total }}</span>
          </dd>
        </div>

        <div>
          <dt>{{ $t('extraordinary campaigns') }}</dt>
          <dd>
            <span class="value">{{ results.campaignStats.difficult }}</span>
          </dd>
        </div>

        <div>
          <dt>{{ $t('HDMA pre-influence') }}</dt>
          <dd>
            <span class="value">
              {{ results.hdmaActiveRounds }} <small>{{ $t('months') }}</small>
            </span>
          </dd>
        </div>
      </dl>

      <dl class="panels">
        <div v-for="item in results.trainingStats" :key="item.type.value">
          <dt>{{ $t('Training :type', { type: item.type.label }) }}</dt>
          <dd>
            <span class="value">
              {{ item.count }}
            </span>
          </dd>
        </div>
      </dl>
    </section>

    <section class="investment-costs">
      <header>
        <h2>{{ $t('Investment costs') }}</h2>
      </header>

      <ul>
        <li v-for="item in results.investmentCosts" :key="item.type.value">
          <span class="type">{{ item.type.label }}</span>
          <span class="value">
            <MoneyDisplay :value="item.value" />
          </span>
        </li>
      </ul>
    </section>
  </div>
</template>

<script setup lang="ts">
import MoneyDisplay from '/@front:components/MoneyDisplay.vue'
import GameLayout from '/@front:layouts/game.vue'
import type { EnumObject } from '/@front:types/shared'

type InvestmentCost = {
  type: EnumObject
  value: number
}

type Results = {
  hdmaActiveRounds: number
  campaignStats: Record<string, string>
  trainingStats: any[]
  investmentCosts: InvestmentCost[]
}

defineOptions({
  layout: [GameLayout],
})

defineProps<{
  results: Results
}>()
</script>
